import { RouteInfo } from "./types";
import { authGuard, permissionGuard } from "./guards/index";
import { UIPAGE } from "@/constants/ui-page.constants";

const ViewSale = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/GenericSale.vue");
const SaleIdentificationStep = () =>
	import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/1-identification-step/IdentificationStep.vue");
const SaleCoverageStep = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/2-coverage-step/CoverageStep.vue");
const SaleCustomerStep = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/3-customer-step/CustomerStep.vue");
const SaleBundleStep = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/4-bundle-step/BundleStep.vue");
const SaleExtrasStep = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/5-extras-step/ExtrasStep.vue");
const SaleFeaturesStep = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/6-features-step/FeaturesStep.vue");
const SaleConfigurationStep = () =>
	import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/7-configuration-step/ConfigurationStep.vue");
const SaleContractStep = () => import(/* webpackChunkName: "chunk-generic-sale" */ "@/views/generic-sale/8-contract-step/ContractStep.vue");

export const GenericSaleRoute: RouteInfo = {
	id: UIPAGE.GENERIC_SALE,
	path: "/generic-sale",
	component: ViewSale,
	guards: [authGuard, permissionGuard],
	title: "genericSale.display",
	icon: "mdi-devices",
	children: [
		{
			id: UIPAGE.GENERIC_SALE_IDENTIFICATION,
			path: "identification",
			component: SaleIdentificationStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_COVERAGE,
			path: ":id/coverage",
			component: SaleCoverageStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_CUSTOMER,
			path: ":id/customer",
			component: SaleCustomerStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_BUNDLE,
			path: ":id/bundle",
			component: SaleBundleStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_EXTRAS,
			path: ":id/extras",
			component: SaleExtrasStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_FEATURES,
			path: ":id/features",
			component: SaleFeaturesStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_CONFIGURATION,
			path: ":id/configuration",
			component: SaleConfigurationStep,
			title: "genericSale.display"
		},
		{
			id: UIPAGE.GENERIC_SALE_CONTRACT,
			path: ":id/contract",
			component: SaleContractStep,
			title: "genericSale.display"
		},
		{
			id: "generic-sale-empty",
			path: "",
			redirect: "identification"
		}
	]
};
